import { render } from "./LongDescription.vue?vue&type=template&id=15f6d04a"
import script from "./LongDescription.vue?vue&type=script&lang=js"
export * from "./LongDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__